import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from "@sentry/react";

const root = ReactDOM.createRoot(document.getElementById('root'));

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://db450567c95a1b35540e9f5822e9a49b@o4510081290928128.ingest.us.sentry.io/4510143789596672",
    sendDefaultPii: true,
    integrations: [
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: false,
        blockAllMedia: false
      })
    ],
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0
  });
}

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
